import { observer } from 'mobx-react-lite'
import './index.scss'


const UserPage = observer(() => {

    return (
        <div className="user-page">
            <div className="container">
            </div>
        </div>
    )
})

export { UserPage }